document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured-collection-tab[data-section-id]').forEach(function (sectionEl) {
    var tabButtons = sectionEl.querySelectorAll('.tab-buttons .tab-button');
    var tabContents = sectionEl.querySelectorAll('.tab-contents .tab-content');
    var shopAllBtns = sectionEl.querySelectorAll('.shop-all-btn');
    
    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.dataset.tab;

        tabButtons.forEach(function (btn) { btn.classList.remove('active'); });
        tabContents.forEach(function (content) { content.classList.remove('active'); });
        button.classList.add('active');

        var targetContent = document.getElementById(target);
        if (targetContent) targetContent.classList.add('active');

        shopAllBtns.forEach(function (a) { a.classList.remove('active'); });
        var activeShopAll = sectionEl.querySelector('.shop-all-btn[data-tab-link="' + target + '"]');
        if (activeShopAll) activeShopAll.classList.add('active');

        setTimeout(function () {
          initSwiper(targetContent);
        }, 50);
      });
    });

    initSwiper(sectionEl.querySelector('.tab-content.active'));
  });
});
